import { useAlertsStore } from '@stores/alertsStore'
import type { AlertsPathType, AlertType } from '@stores/alertsStore'
import Alert from '@atoms/Alert'

type AppAlertsProps = {
  alertsPath: AlertsPathType
  className?: string
}

type ZustandAlertsProps = {
  alerts: AlertType[]
  removeAlert: (indexToRemove: number) => void
}

const ZustandAlerts = ({ alerts, removeAlert }: ZustandAlertsProps) => {
  return (
    <>
      {alerts?.map(({ type, details, icon }, index) => (
        <Alert
          key={`${details.title}-${index}`}
          type={type}
          icon={icon}
          title={details.title}
          onClose={() => {
            removeAlert(index)
          }}
        >
          <p className="tw:text-base">{details.description}</p>
        </Alert>
      ))}
    </>
  )
}

export const AppAlerts = ({ alertsPath, className }: AppAlertsProps) => {
  const { alerts: allAlerts, clearAlert } = useAlertsStore(({ alerts, clearAlert }) => ({
    alerts,
    clearAlert,
  }))
  const alerts = allAlerts[alertsPath] ?? []
  const removeAlert = (indexToRemove: number) => {
    clearAlert(alertsPath, indexToRemove)
  }

  if (alerts.length === 0) return null

  return (
    <div className={`tw:space-y-2 ${className ?? ''}`}>
      <ZustandAlerts alerts={alerts} removeAlert={removeAlert} />
    </div>
  )
}
